var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-light logout",on:{"click":_vm.logout}},[_vm._v("Logi välja")])}
var staticRenderFns = []

export { render, staticRenderFns }